import React, { useState, useEffect, useMemo } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { SelectCampaignEmails } from "./selectCampaignEmails";
import RichTextEditor from "../common/richTextEditor";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import EmailDynamicContentInfo from "../common/emailDynamicContentInfo";
import ConfirmationPopup from "../common/confirmationPopup";
import AlertPopup from "../common/alertPopup";
const AddEmailCampaign = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [alertMessage, setAlertMessage] = useState([]);
  const [reminderCountLimit, setReminderCountLimit] = useState(0);
  const [reminderInterval, setreminderInterval] = useState(0);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]);
  const [emailData, setEmailData] = useState({});
  const [errors, setErrors] = useState({});
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [alertInitialPopup, setAlertInitialPopup] = useState(false);
  const [sendHeader, setSendHeader] = useState(false);
  const [sendFooter, setSendFooter] = useState(false);
  const [showReminderEmail, setShowReminderEmail] = useState(false);
  const [isEmailAccordionOpen, setIsEmailAccordionOpen] = useState(false);
  const [isReminderAccordionOpen, setIsReminderAccordionOpen] = useState(false);
  const [emailConfig, setEmailConfig] = useState(null); // store original config
  const [filterRefresh, setFilterRefresh] = useState(0);
  const [scheduledDateTime, setScheduledDateTime] = useState(null);
  const [dateTimeError, setDateTimeError] = useState("");
  const [accountFilter, setAccountFilter] = useState(24);
  const [customHoursFilter, setCustomHoursFilter] = useState("");
  const [showDraftConfirmPopup, setShowDraftConfirmPopup] = useState(false);
  const [emailCampaignName, setEmailCampaignName] = useState("");
  const [emailType, setEmailType] = useState("");
  const [campaignNameError, setCampaignNameError] = useState("");
  const [userEditedLimit, setUserEditedLimit] = useState(false);
  const [userEditedInterval, setUserEditedInterval] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");
  const intervalOptions = [24, 48, 96];
  const [allAccountsDisabled, setAllAccountsDisabled] = useState(false);
  const [isCustomInterval, setIsCustomInterval] = useState(false);
  const [isScheduleRequired, setIsScheduleRequired] = useState(false);
  const emailTypes = [
    { name: t("logged_in_ordered_email_txt"), value: "logged_in_not_order" },
    {
      name: t("logged_in_ordered_email_cutoff_txt"),
      value: "logged_in_not_order_cutoff",
    },
    { name: t("abandoned_cart_email_txt"), value: "abandoned_cart" },
  ];
  const [emailTypeOptions, setEmailTypeOptions] = useState([]);
  const [holidays, setHolidays] = useState([]);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized";
  }
  useEffect(() => {
    http
      .get(BaseUrl + "admin/holidays")
      .then((response) => {
        const dates = response.data.data.map((h) =>
          new Date(h.holidayDate).setHours(0, 0, 0, 0)
        );
        setHolidays(dates);
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    fetchEmailConfig();
  }, [emailType]);

  const clearEmailFormData = () => {
    setEmailData({});
    setReminderCountLimit(0);
    setreminderInterval(0);
    setEmailConfig(null);
    setErrors({});
  };

  const fetchEmailConfig = async () => {
    try {
      const response = await http.get(BaseUrl + "admin/emailConfigs");
      if (response.data.success) {
        const activeConfigs = response.data.data.filter(
          (item) => item.status === "active"
        );
        const emailConfigs = emailTypes
          .filter((type) =>
            activeConfigs.some((item) => item.emailType === type.value)
          )
          .map((type) => ({
            name: type.name,
            value: type.value,
          }));
        if (emailConfigs.length === 0) {
          setAlertInitialPopup(true);
        } else {
          setEmailTypeOptions(emailConfigs);
        }
        const config = activeConfigs.find(
          (item) => item.emailType === emailType
        );
        if (emailType && config) {
          setEmailData({
            emailSubject: config.emailSubject,
            emailContent: config.emailContent,
            reminderEmailSubject: config.reminderEmailSubject || "",
            reminderEmailContent: config.reminderEmailContent || "",
          });
          setSendHeader(config.header);
          setSendFooter(config.footer);
          setEmailConfig(config);
          setEmailType(config.emailType);
          setReminderCountLimit(Number(config.reminderCountLimit) || 0);
          const defaultIntervals = [24, 48, 96];
          const interval = Number(config.reminderInterval) || 0;
          if (!defaultIntervals.includes(interval)) {
            setIsCustomInterval(true);
            setreminderInterval(interval);
          } else {
            setIsCustomInterval(false);
            setreminderInterval(interval);
          }
          setUserEditedLimit(false);
          setUserEditedInterval(false);
        } else {
          clearFormData();
          clearEmailFormData();
        }
      }
    } catch (err) {
      console.error(t("fetch_email_config_fail_msg"), err);
    }
  };

  const toggleEmailAccordion = () => setIsEmailAccordionOpen((prev) => !prev);
  const toggleReminderAccordion = () =>
    setIsReminderAccordionOpen((prev) => !prev);

  const handleReminderLimitChange = (e) => {
    const value = e.target.value;
    setReminderCountLimit(value === "" ? "" : Number(value.replace(/\D/g, "")));
    setUserEditedLimit(true);
    setErrors((prev) => ({ ...prev, reminderInterval: "" }));
  };

  const handleMailIntervalChange = (e) => {
    const value = e.target.value;
    setreminderInterval(value === "" ? "" : Number(value.replace(/\D/g, "")));
    setUserEditedInterval(true);
    setErrors((prev) => ({ ...prev, reminderInterval: "" }));
  };

  const handleChangeEmailContent = (value) => {
    setEmailData((prev) => ({ ...prev, emailContent: value }));
    setErrors((prev) => ({ ...prev, emailContent: "" }));
  };

  const handleReminderEmailContentChange = (value) => {
    setEmailData((prev) => ({ ...prev, reminderEmailContent: value }));
    setErrors((prev) => ({ ...prev, reminderEmailContent: "" }));
  };

  const formvalidation = (validateSchedule = false) => {
    const errmsg = {};
    let isValid = true;
    let openAccordions = { primary: false, reminder: false };
    if (!selectedAccounts || selectedAccounts.length === 0) {
      errmsg.accountCodes = t("please_select_at_least_one_account_txt");
      isValid = false;
    }
    if (!emailType || emailType.trim() === "") {
      errmsg.emailType = t("field_require_txt");
      isValid = false;
    }
    if (!emailData.emailSubject || emailData.emailSubject.trim() === "") {
      errmsg.emailSubject = t("field_require_txt");
      isValid = false;
      openAccordions.primary = true;
    }
    if (!emailData.emailContent || emailData.emailContent.trim() === "") {
      errmsg.emailContent = t("field_require_txt");
      isValid = false;
      openAccordions.primary = true;
    }
    // Validate reminder email only if checkbox is checked
    if (showReminderEmail) {
      if (!isCustomInterval) {
        if (
          !reminderInterval ||
          reminderInterval === "" ||
          reminderInterval === "0"
        ) {
          errmsg.reminderInterval = t("field_require_txt");
          isValid = false;
          openAccordions.reminder = true;
        }
      } else {
        if (
          !reminderInterval ||
          reminderInterval === "" ||
          reminderInterval === 0
        ) {
          errmsg.customReminderInterval = t("field_require_txt");
          isValid = false;
          openAccordions.reminder = true;
        }
      }
      if (
        !emailData.reminderEmailSubject ||
        emailData.reminderEmailSubject.trim() === ""
      ) {
        errmsg.reminderEmailSubject = t("field_require_txt");
        isValid = false;
        openAccordions.reminder = true;
      }
      if (
        !emailData.reminderEmailContent ||
        emailData.reminderEmailContent.trim() === ""
      ) {
        errmsg.reminderEmailContent = t("field_require_txt");
        isValid = false;
        openAccordions.reminder = true;
      }
    }
    if (validateSchedule === "schedule") {
      if (!scheduledDateTime) {
        setDateTimeError(t("please_select_schedule_date_time_txt"));
        isValid = false;
      } else if (scheduledDateTime < new Date()) {
        setDateTimeError(t("scheduled_date_time_must_be_future_txt"));
        isValid = false;
      } else {
        setDateTimeError("");
      }
    } else if (validateSchedule === "draft") {
      // if entered must be future
      if (scheduledDateTime) {
        if (scheduledDateTime <= new Date()) {
          setDateTimeError(t("scheduled_date_time_must_be_future_txt"));
          isValid = false;
        } else {
          setDateTimeError("");
        }
      } else {
        // empty allowed
        setDateTimeError("");
      }
    }
    setErrors(errmsg);
    return { isValid, openAccordions };
  };

  useEffect(() => {
    if (selectedAccounts && selectedAccounts.length > 0) {
      setErrors((prev) => ({ ...prev, accountCodes: "" }));
    }
  }, [selectedAccounts]);

  const handleSendToAllClick = () => {
    setIsScheduleRequired(true);
    const { isValid, openAccordions } = formvalidation("schedule");
    setCampaignNameError("");
    if (!emailCampaignName || emailCampaignName.trim() === "") {
      setCampaignNameError(t("field_require_txt"));
      setTimeout(() => {
        const firstError = document.querySelector(".error-msg");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
          firstError.classList.add("highlight-error");
          setTimeout(
            () => firstError.classList.remove("highlight-error"),
            2000
          );
        }
      }, 100);
      return;
    }
    if (!isValid) {
      // Auto-open accordions
      if (openAccordions.primary) setIsEmailAccordionOpen(true);
      if (openAccordions.reminder) setIsReminderAccordionOpen(true);
      // Wait for React to render the error messages
      setTimeout(() => {
        const firstError = document.querySelector(".error-msg");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
          firstError.classList.add("highlight-error");
          setTimeout(
            () => firstError.classList.remove("highlight-error"),
            2000
          );
        }
      }, 100);
      return;
    }
    setShowConfirmPopup(true);
  };

  const btnsubmit = (e) => {
    setIsLoading(true);
    const enabledAccounts = selectedAccounts.filter(
      (acc) => !acc.alreadyQueued
    );
    const selectedCodes = selectedAccounts.map((a) => a.accountCode);
    const allCodes = allAccounts.map((a) => a.accountCode);
    const blockedAccounts = allCodes.filter(
      (code) => !selectedCodes.includes(code)
    );
    const payload = {
      accounts: enabledAccounts,
      blockedAccounts: blockedAccounts,
      emailSubject: emailData.emailSubject,
      emailContent: emailData.emailContent,
      header: sendHeader,
      footer: sendFooter,
      reminderCountLimit: showReminderEmail ? reminderCountLimit : 0,
      reminderInterval: showReminderEmail ? reminderInterval : 0,
      reminderEmailSubject: emailData.reminderEmailSubject,
      reminderEmailContent: emailData.reminderEmailContent,
      emailType: emailType,
      scheduledSendTime: scheduledDateTime || null,
      cutoffTime: customHoursFilter
        ? Number(customHoursFilter)
        : Number(accountFilter),
      status: "scheduled",
      runStatus: "run",
      emailCampaignName: emailCampaignName,
      autoEmail: emailData?.autoEmail || false,
    };
    let URL = BaseUrl + "admin/createEmailCampaign";
    http
      .post(URL, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.success === true) {
          setAlertPopup(true);
          setAlertMessage(t("email_campaign_scheduled_successfully_txt"));
          setRedirectPath({
            path: "/email-logs",
            state: { activeTab: "Email Scheduled" },
          });
          clearFormData();
        }
      })
      .catch(() => {
        setIsLoading(false);
        setAlertErrorPopup(true);
        setAlerterrMessage(t("failed_to_send_emails_txt"));
      });
    setShowConfirmPopup(false);
  };
  // show confirmation popup for draft
  const handleSaveAsDraftClick = () => {
    setIsScheduleRequired(false);
    const { isValid, openAccordions } = formvalidation("draft");
    setCampaignNameError("");
    if (!emailCampaignName || emailCampaignName.trim() === "") {
      setCampaignNameError(t("field_require_txt"));
      setTimeout(() => {
        const firstError = document.querySelector(".error-msg");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
          firstError.classList.add("highlight-error");
          setTimeout(
            () => firstError.classList.remove("highlight-error"),
            2000
          );
        }
      }, 100);
      return;
    }
    if (!isValid) {
      if (openAccordions.primary) setIsEmailAccordionOpen(true);
      if (openAccordions.reminder) setIsReminderAccordionOpen(true);
      setTimeout(() => {
        const firstError = document.querySelector(".error-msg");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
          firstError.classList.add("highlight-error");
          setTimeout(
            () => firstError.classList.remove("highlight-error"),
            2000
          );
        }
      }, 100);
      return;
    }
    setShowDraftConfirmPopup(true);
  };

  // draft submit
  const draftBtnSubmit = () => {
    setIsLoading(true);
    const enabledAccounts = selectedAccounts.filter(
      (acc) => !acc.alreadyQueued
    );
    const selectedCodes = selectedAccounts.map((a) => a.accountCode);
    const allCodes = allAccounts.map((a) => a.accountCode);
    const blockedAccounts = allCodes.filter(
      (code) => !selectedCodes.includes(code)
    );
    const payload = {
      accounts: enabledAccounts,
      blockedAccounts: blockedAccounts,
      emailSubject: emailData.emailSubject,
      emailContent: emailData.emailContent,
      header: sendHeader,
      footer: sendFooter,
      reminderCountLimit: showReminderEmail ? reminderCountLimit : 0,
      reminderInterval: showReminderEmail ? reminderInterval : 0,
      reminderEmailSubject: emailData.reminderEmailSubject,
      reminderEmailContent: emailData.reminderEmailContent,
      emailType: emailType,
      scheduledSendTime: scheduledDateTime || null,
      cutoffTime: customHoursFilter
        ? Number(customHoursFilter)
        : Number(accountFilter),
      status: "draft",
      runStatus: "pause",
      emailCampaignName: emailCampaignName,
      autoEmail: emailData?.autoEmail || false,
    };
    let draftURL = BaseUrl + "admin/createEmailCampaign";
    http
      .post(draftURL, payload)
      .then((response) => {
        setIsLoading(false);

        if (response.data.success === true) {
          if (response.data.message.startsWith("Draft Exist for")) {
            const viewEmailType =
              emailType === "abandoned_cart"
                ? t("abandoned_cart_email_txt")
                : t("logged_in_ordered_email_txt");
            setAlerterrMessage(
              t("draft_exist_error_msg", {
                emailType: viewEmailType,
              })
            );
            setAlertErrorPopup(true);
          } else {
            setAlertPopup(true);
            setAlertMessage(t("email_campaign_draft_save_successfully_txt"));
            setRedirectPath("/email-campaign");
            clearFormData();
          }
        }
      })
      .catch(() => {
        setIsLoading(false);
        setAlertErrorPopup(true);
        setAlerterrMessage(t("failed_to_save_draft_txt"));
        setTimeout(() => setAlertErrorPopup(false), 3000);
      });
    setShowDraftConfirmPopup(false);
  };
  // Cancel button
  const handleCancel = () => {
    navigate("/email-campaign");
  };

  const clearFormData = () => {
    setSelectedAccounts([]);
    setFilterRefresh((prev) => prev + 1);
  };

  const formatHoursToDays = (hours) => {
    if (!hours || isNaN(hours)) return "";
    const totalHours = parseInt(hours, 10);
    const days = Math.floor(totalHours / 24);
    const remaining = totalHours % 24;
    let result = "";
    if (days > 0) {
      result += `${days} day${days > 1 ? "s" : ""}`;
    }
    if (remaining > 0) {
      if (result) result += " ";
      result += `${remaining} hour${remaining > 1 ? "s" : ""}`;
    }
    return result || "0 hours";
  };
  const closeSuccessAlert = () => {
    setAlertPopup(false);
    if (typeof redirectPath === "object" && redirectPath.path) {
      navigate(redirectPath.path, { state: redirectPath.state });
    } else {
      navigate(redirectPath);
    }
  };

  return (
    <section className="dashboard-block">
      {alerterrorPopup && (
        // <ShowAlert title={t("alert_txt")} message={alerterrMessage} />
        <AlertPopup
          title={t("alert_txt")}
          message={t(alerterrMessage)}
           handleOk={() => {
            setAlertErrorPopup(false);
            navigate("/email-campaign");
          }}
        />
      )}
      {alertPopup && (
        <CommonAlert
          title={t("alert_txt")}
          message={alertMessage}
          redirectTo={redirectPath}
        />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">
              {t("add_email_campaign_title_txt")}
            </h1>
            <div className="right-table-outer-wrap">
              <div className="form-field freeproduct-fieldset masterentry-fieldset">
                <form
                  className="sectors-detail-form"
                  onSubmit={(e) => e.preventDefault()}
                >
                  {/* <div className="input-field col2">
                    <label>Email Campaign Name</label>
                    <input
                      type="text"
                      name="emailCampaignName"
                      value={emailCampaignName}
                      onChange={(e) => {
                        const val = e.target.value;
                      }}
                      placeholder="Enter Campaign Name"
                    />
                    {errors.emailCampaignName && (
                      <div className="error-msg">
                        {errors.emailCampaignName}
                      </div>
                    )}
                  </div>
                  <div className="input-field col2">
                    <label>Email Type</label>
                    <select
                      value={emailType}
                      name="emailType"
                      onChange={(e) => {
                        const selectedType = e.target.value;
                        setEmailType(selectedType);
                        setFilterRefresh((prev) => prev + 1);
                        // if (setEmailTypeError) setEmailTypeError("");
                      }}
                    >
                      <option value="logged_in_not_order">
                        Logged In - Not Ordered
                      </option>
                      <option value="abandoned_cart">Abandoned Cart</option>
                    </select>
                    {errors.emailType && (
                      <div className="error-msg">{errors.emailType}</div>
                    )}
                  </div> */}
                  <SelectCampaignEmails
                    setSelectedAccounts={setSelectedAccounts}
                    setAllAccounts={setAllAccounts}
                    filterRefresh={filterRefresh}
                    setFilterRefresh={setFilterRefresh}
                    setAccountFilter={setAccountFilter}
                    setCustomHoursFilter={setCustomHoursFilter}
                    setEmailCampaignName={setEmailCampaignName}
                    emailType={emailType}
                    setEmailType={setEmailType}
                    campaignNameError={campaignNameError}
                    setCampaignNameError={setCampaignNameError}
                    errors={errors}
                    setErrors={setErrors}
                    emailTypeOptions={emailTypeOptions}
                    emailData={emailData}
                    setEmailData={setEmailData}
                    setAllAccountsDisabled={setAllAccountsDisabled}
                  />
                  <div className="input-field">
                    {errors.accountCodes && (
                      <div className="error-msg">{errors.accountCodes}</div>
                    )}
                  </div>
                  <div className="accordion-box input-field">
                    <div
                      onClick={toggleEmailAccordion}
                      className={
                        isEmailAccordionOpen
                          ? "accordion-header show"
                          : "accordion-header"
                      }
                    >
                      <h2>
                        {t("primary_email_configuration_txt")}
                        {emailType &&
                          (() => {
                            const selectedType = emailTypeOptions.find(
                              (opt) => opt.value === emailType
                            );
                            return selectedType
                              ? ` (${selectedType.name})`
                              : "";
                          })()}
                      </h2>
                      <span className="show-accordion"></span>
                    </div>
                    <div
                      className="accordion-body"
                      style={{
                        display: isEmailAccordionOpen ? "block" : "none",
                      }}
                    >
                      <div className="input-field">
                        <div className="note-text">
                          <strong>{t("default_email_content_note")}</strong>
                        </div>
                      </div>
                      {/* Email Subject */}
                      <div className="input-field">
                        <br />
                        <label>{t("email_subject_txt")}<span className="color-red">*</span></label>
                        <input
                          type="text"
                          name="EmailSubject"
                          value={emailData.emailSubject || ""}
                          onChange={(e) => {
                            setEmailData((prev) => ({
                              ...prev,
                              emailSubject: e.target.value,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              emailSubject: "",
                            }));
                          }}
                        />
                        {errors.emailSubject && (
                          <div className="error-msg">{errors.emailSubject}</div>
                        )}
                      </div>
                      {/* Email Content */}
                      <div className="input-field">
                        <label>{t("email_content_txt")}<span className="color-red">*</span></label>
                        <EmailDynamicContentInfo emailType={emailType} />
                        <br />
                        <RichTextEditor
                          emailContent={emailData.emailContent}
                          handleChangeEmailContent={handleChangeEmailContent}
                        />
                        {errors.emailContent && (
                          <div className="error-msg">{errors.emailContent}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="input-field">
                    <label htmlFor="reminderEmail">
                      {t("send_reminder_email_txt")}
                    </label>
                    <div className="switch-button switch-button-sm">
                      <input
                        type="checkbox"
                        id="reminderEmail"
                        name="reminderEmail"
                        className="checkbox"
                        checked={showReminderEmail}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setShowReminderEmail(checked);
                          if (!checked) {
                            setErrors((prev) => ({
                              ...prev,
                              reminderInterval: "",
                              reminderEmailSubject: "",
                              reminderEmailContent: "",
                            }));
                          } else {
                            setReminderCountLimit((prev) => {
                              if (!userEditedLimit) {
                                return (
                                  Number(emailConfig?.reminderCountLimit) || 0
                                );
                              }
                              return prev;
                            });
                            setreminderInterval((prev) => {
                              if (!userEditedInterval) {
                                return (
                                  Number(emailConfig?.reminderInterval) || 0
                                );
                              }
                              return prev;
                            });
                            setEmailData((prev) => {
                              const subject = prev.reminderEmailSubject?.trim();
                              const content = prev.reminderEmailContent?.trim();
                              return {
                                ...prev,
                                reminderEmailSubject:
                                  subject === ""
                                    ? ""
                                    : subject ||
                                      emailConfig?.reminderEmailSubject ||
                                      "",
                                reminderEmailContent:
                                  content === ""
                                    ? ""
                                    : content ||
                                      emailConfig?.reminderEmailContent ||
                                      "",
                              };
                            });
                          }
                        }}
                      />
                      <div className="knobs">
                        <span></span>
                      </div>
                      <div className="layer"></div>
                    </div>
                  </div>
                  {showReminderEmail && (
                    <div className="accordion-box input-field">
                      <div
                        onClick={toggleReminderAccordion}
                        className={
                          isReminderAccordionOpen
                            ? "accordion-header show"
                            : "accordion-header"
                        }
                      >
                        <h2>
                          {t("reminder_email_configuration_txt")}
                          {emailType &&
                            (() => {
                              const selectedType = emailTypeOptions.find(
                                (opt) => opt.value === emailType
                              );
                              return selectedType
                                ? ` (${selectedType.name})`
                                : "";
                            })()}
                        </h2>
                        <span className="show-accordion"></span>
                      </div>
                      <div
                        className="accordion-body"
                        style={{
                          display: isReminderAccordionOpen ? "block" : "none",
                        }}
                      >
                        <div className="input-field">
                          <div className="note-text">
                            <strong>{t("default_email_content_note")}</strong>
                          </div>
                        </div>
                        <div className="flex-bx-wrap col3">
                          <div className="flex-bx-item">
                            <div className="input-field">
                              <label htmlFor="reminderCountLimit">
                                {t("reminder_limit_txt")}
                              <span className="color-red">*</span>
                              </label>
                              <input
                                type="text"
                                name="reminderCountLimit"
                                value={reminderCountLimit}
                                placeholder={t("reminder_limit_text")}
                                min="1"
                                onKeyDown={(e) => {
                                  if (
                                    !/[0-9]/.test(e.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onPaste={(e) => {
                                  if (
                                    !/^\d*$/.test(
                                      e.clipboardData.getData("Text")
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={handleReminderLimitChange}
                              />
                              {errors.reminderCountLimit && (
                                <div className="error-msg">
                                  {errors.reminderCountLimit}
                                </div>
                              )}
                            </div>
                          </div>
                          {/* Reminder Mail Send Interval */}
                          <div className="flex-bx-item">
                            <div className="input-field">
                              <label>
                                {t("reminder_email_interval_txt")}
                                {/* {reminderInterval > 23 && !isCustomInterval && (
                                  <span className="note-text">
                                    {" - "}{" "}
                                    {formatHoursToDays(reminderInterval)}
                                  </span>
                                )} */}
                              <span className="color-red">*</span>
                              </label>
                              <select
                                value={
                                  isCustomInterval
                                    ? "custom"
                                    : reminderInterval || ""
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === "custom") {
                                    setIsCustomInterval(true);
                                    setreminderInterval(""); // <-- start empty instead of 24
                                  } else if (value === "") {
                                    setIsCustomInterval(false);
                                    setreminderInterval(""); // handle placeholder
                                  } else {
                                    setIsCustomInterval(false);
                                    setreminderInterval(Number(value));
                                  }
                                  setErrors((prev) => ({
                                    ...prev,
                                    reminderInterval: "",
                                  }));
                                  setErrors((prev) => ({
                                    ...prev,
                                    customReminderInterval: "",
                                  }));
                                }}
                              >
                                <option value="">
                                  {t("select_interval_txt")}
                                </option>
                                {intervalOptions.map((opt) => (
                                  <option key={opt} value={opt}>
                                    {opt} hours
                                  </option>
                                ))}
                                <option value="custom">
                                  {t("custom_txt")}
                                </option>
                              </select>
                              {errors.reminderInterval && (
                                <div className="error-msg">
                                  {errors.reminderInterval}
                                </div>
                              )}
                            </div>
                          </div>
                          {isCustomInterval && (
                            <div className="flex-bx-item">
                              <div className="input-field">
                                <label>
                                  {t("add_custom_hours_txt")}
                                  {/* {reminderInterval >= 24 && (
                                    <span className="note-text">
                                      {" - "}{" "}
                                      {formatHoursToDays(reminderInterval)}
                                    </span>
                                  )} */}
                                <span className="color-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  value={reminderInterval}
                                  placeholder={t("custom_hrs_text")}
                                  onKeyDown={(e) => {
                                    if (
                                      !/[0-9]/.test(e.key) &&
                                      ![
                                        "Backspace",
                                        "Delete",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Tab",
                                      ].includes(e.key)
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onPaste={(e) => {
                                    if (
                                      !/^\d*$/.test(
                                        e.clipboardData.getData("Text")
                                      )
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setreminderInterval(
                                      value === "" ? "" : Number(value)
                                    );
                                    setErrors((prev) => ({
                                      ...prev,
                                      reminderInterval: "",
                                    }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      customReminderInterval: "",
                                    }));
                                  }}
                                />
                                {errors.customReminderInterval && (
                                  <div className="error-msg">
                                    {errors.customReminderInterval}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        {/* Reminder Email Subject */}
                        <div className="input-field">
                          <label>{t("reminder_email_subject_txt")}<span className="color-red">*</span></label>
                          <input
                            type="text"
                            name="reminderEmailSubject"
                            value={emailData.reminderEmailSubject || ""}
                            onChange={(e) => {
                              setEmailData((prev) => ({
                                ...prev,
                                reminderEmailSubject: e.target.value,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                reminderEmailSubject: "",
                              }));
                            }}
                          />
                          {errors.reminderEmailSubject && (
                            <div className="error-msg">
                              {errors.reminderEmailSubject}
                            </div>
                          )}
                        </div>
                        {/* Reminder Email Content */}
                        <div className="input-field">
                          <label>{t("reminder_email_content_txt")}<span className="color-red">*</span></label>
                          <EmailDynamicContentInfo emailType={emailType} />
                          <br />
                          <RichTextEditor
                            key={showReminderEmail ? "reminder" : "none"}
                            emailContent={emailData.reminderEmailContent || ""}
                            handleChangeEmailContent={
                              handleReminderEmailContentChange
                            }
                          />
                          {errors.reminderEmailContent && (
                            <div className="error-msg">
                              {errors.reminderEmailContent}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                <div className="grid grid-cols-3 gap-md">
                  <div className="grid-item">
                  <div className="input-field">
                    <br />
                    <label>{t("schedule_email_date_time_txt")}{isScheduleRequired && <span className="color-red">*</span>}</label>
                    <br />
                    {/* <DatePicker
                      selected={scheduledDateTime}
                      onChange={(date) => {
                        // If user only selects date, set time to current time if it's today
                        const now = new Date();
                        if (
                          date &&
                          date.toDateString() === now.toDateString() &&
                          (!scheduledDateTime ||
                            (scheduledDateTime.getHours() === 0 &&
                              scheduledDateTime.getMinutes() === 0))
                        ) {
                          date.setHours(now.getHours());
                          date.setMinutes(now.getMinutes());
                        }
                        setScheduledDateTime(date);
                        if (date) setDateTimeError("");
                      }}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="dd-MM-yyyy HH:mm"
                      minDate={new Date()}
                      minTime={
                        scheduledDateTime &&
                        scheduledDateTime.toDateString() ===
                          new Date().toDateString()
                          ? new Date()
                          : new Date().setHours(0, 0, 0, 0)
                      }
                      maxTime={new Date().setHours(23, 45, 0, 0)}
                      placeholderText="Select date and time"
                    /> */}
                    <DatePicker
                      selected={scheduledDateTime}
                      onChange={(date) => {
                        const now = new Date();

                        if (
                          date &&
                          date.toDateString() === now.toDateString() &&
                          (!scheduledDateTime ||
                            (scheduledDateTime.getHours() === 0 &&
                              scheduledDateTime.getMinutes() === 0))
                        ) {
                          date.setHours(now.getHours());
                          date.setMinutes(now.getMinutes());
                        }

                        setScheduledDateTime(date);
                        if (date) setDateTimeError("");
                      }}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="dd-MM-yyyy HH:mm"
                      minDate={new Date()}
                      minTime={
                        scheduledDateTime &&
                        scheduledDateTime.toDateString() ===
                          new Date().toDateString()
                          ? new Date()
                          : new Date().setHours(0, 0, 0, 0)
                      }
                      maxTime={new Date().setHours(23, 45, 0, 0)}
                      placeholderText={t("date_time_placeholder_txt")}
                      /* 🔥 Disable Weekends + Holidays */
                      filterDate={(date) => {
                        const day = date.getDay();

                        // ❌ Disable Saturday and Sunday
                          if (day === 0 || day === 6) return false;

                        // ❌ Disable holidays loaded from API
                        const isHoliday = holidays.includes(
                          date.setHours(0, 0, 0, 0)
                        );

                        return !isHoliday;
                      }}
                    />

                    {dateTimeError && (
                      <div className="error-msg">{dateTimeError}</div>
                    )}
                  </div>
                  </div>
                </div>

                  <div className="btnfield">
                    <button
                      type="button"
                      className="btn-draft"
                      onClick={handleSaveAsDraftClick}
                      disabled={allAccountsDisabled || isLoading}
                    >
                      {t("save_as_draft_btn_txt")}
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn-send"
                      onClick={handleSendToAllClick}
                      disabled={allAccountsDisabled || isLoading}
                    >
                      {t("schedule_and_send_txt")}
                    </button>
                    &nbsp;&nbsp;
                    <button type="button" onClick={handleCancel}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
                {isLoading && (
                  <div className="loading-full-bg">
                    <div className="loading-buffer"></div>
                  </div>
                )}
                {showConfirmPopup && (
                  <ConfirmationPopup
                    title={t("sendemail_popup_title")}
                    confirmationMessage={
                    <span
                        dangerouslySetInnerHTML={{
                          __html: t("sendmail_confirm_txt", { count: selectedAccounts?.length || 0 }),
                        }}
                      />
                    }
                    handleYes={btnsubmit}
                    handleNo={() => setShowConfirmPopup(false)}
                  />
                )}
                {showDraftConfirmPopup && (
                  <ConfirmationPopup
                    title={t("draftmail_popup_title")}
                    confirmationMessage={t("draftmail_confirm_txt")}
                    handleYes={draftBtnSubmit}
                    handleNo={() => setShowDraftConfirmPopup(false)}
                  />
                )}
                {alertInitialPopup && (
                  <CommonAlert
                    title={t("emailsetup_requie_txt")}
                    message={t("emailsetup_alert_txt")}
                    redirectTo="/email-configuration"
                  />
                )}
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default AddEmailCampaign;
